import { render, staticRenderFns } from "./IndexInvestor.vue?vue&type=template&id=14124f7e&scoped=true&"
import script from "./IndexInvestor.vue?vue&type=script&lang=js&"
export * from "./IndexInvestor.vue?vue&type=script&lang=js&"
import style0 from "./IndexInvestor.vue?vue&type=style&index=0&id=14124f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14124f7e",
  null
  
)

export default component.exports